import { Preview } from './Preview';
import { Footer } from './Footer';
import { PreviewContainer } from '../../common';
import { TemplateEditViews } from '../../common/types';
import { useQueryParamContext } from '../../context/QueryParamContext';
import { PreviewHeader } from '../../common/PreviewHeader';

export const TEMPLATE_EDITOR_EMAIL_PREVIEW_PANE_ID = 'template-editor-email-preview-pane';

export const PreviewPane = () => {
  const { view } = useQueryParamContext();
  const isPreviewWithData = view === TemplateEditViews.preview;

  return (
    <PreviewContainer
      data-test={TEMPLATE_EDITOR_EMAIL_PREVIEW_PANE_ID}
      isPreviewWithData={isPreviewWithData}
    >
      <PreviewHeader />
      <Preview />
      <Footer />
    </PreviewContainer>
  );
};

export default PreviewPane;
